import awsmobile from '../config/aws-exports';
import { apiRequestTyped } from '../utils/apiRequestTyped';

/**
 * List of system features currently available
 */
export enum SystemFeatures {
  OPTIMISE_SIMULATION_USERS = 'optimise_simulation_users',
  TARIFF_SIM = 'tariff_sim',
  USER_SUBS_DISABLED = 'user_subs_disabled',
}

/**
 * API response containing the list of enabled system features
 *
 * @interface
 * @property {string[]} enabled_features - Array of feature keys currently enabled in the system
 */
interface EnabledSystemFeaturesResponse {
  enabled_features: string[];
}

/**
 * Retrieves enabled system features.
 *
 * Sends a GET request to retrieve the list of enabled system features.
 *
 * @async
 * @function getEnabledSystemFeatures
 * @returns {Promise<any>} - A promise that resolves to the response from the API containing the enabled system features.
 */
export const getEnabledSystemFeatures = async (): Promise<EnabledSystemFeaturesResponse> =>
  await apiRequestTyped(`${awsmobile.optimise_endpoint_auth}/enabled-system-features`);
